(function() {
    'use strict';

    angular.module('settings')
        .controller('FaqListController', FaqListController);

    FaqListController.$inject = ['$state', 'faqDataSrvc', 'faqSrvc', 'notificationSrvc', 'faqMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'faqSectionsConst', 'faqPermissionsConst', 'filterQuerySrvc'];

    function FaqListController($state, faqDataSrvc, faqSrvc, notificationSrvc, faqMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, faqSectionsConst, faqPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.faqRows = [];
        self.faqCols = [{
            title: 'Nazwa',
            value: 'title',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Sekcja',
            value: 'section',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = faqPermissionsConst;
        self.searchQuery = {
            title: null,
            section: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getFaq();
        }

        function getFaq(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    title: self.searchQuery.title || undefined,
                    section: self.searchQuery.section || undefined,
                    ordering: self.searchQuery.ordering
                };
            }
            return faqDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.faqRows = response.results;
                        self.pageOpts.count = response.count;

                        for (var i = 0; i < self.faqRows.length; ++i) {
                            self.faqRows[i].section = faqSectionsConst.find(function(item) {
                                return item.code === self.faqRows[i].section;
                            }).title;
                        }

                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getFaq);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.faq.create');
        }

        function onEdit(row) {
            $state.go('layout.faq.update', { pk: row.pk });
        }

        function onDelete(row) {
            return faqSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", faqMessagesConst.delete);
                lodashService.remove(self.faqRows, { pk: row.pk });
                return response;
            }, function(error) {
                notificationSrvc.notification("error", error.data.detail);
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getFaq();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getFaq();
        }
    }
})();
